import { useLoginForm } from './Form.h'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import { FormProvider } from 'react-hook-form'
import { Link as RRDLink } from 'react-router-dom'
import FormTextField from '@shared/components/FormTextField'

export default function Login() {
    const {
        form,
        mutate
    } = useLoginForm()

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(mutate)}>
                <Stack>
                    <Typography variant='h5'>تسجيل الدخول</Typography>
                    <br />
                    <FormTextField
                        name='email'
                        label='البريد الإلكتروني'
                    />
                    <FormTextField
                        name='password'
                        label='كلمة المرور'
                        type='password'
                    />
                    <Link
                        component={RRDLink}
                        to='/auth/recovery-password'
                        underline='none'
                    >نسيت كلمة المرور؟</Link>
                    <br />
                    <Box sx={{
                        display:'flex',
                        flexDirection:'row-reverse',
                        justifyContent:'space-between'
                    }}>
                        <Button
                            type='submit'
                            variant='contained'
                            sx={{boxShadow: 0}}
                        >الدخول</Button>
                        <Button
                            component={RRDLink}
                            to='/auth/signup'
                        >إنشاء حساب</Button>
                    </Box>
                </Stack>
            </form>
        </FormProvider>
    )
}
